var _path, _path2, _path3, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuturesFundingRateProfit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.57 13.1a1 1 0 0 0-1.91.59l1.91-.58Zm-1.14 6.04.94.35-.94-.35Zm-17.28-1.5.98-.18-.98.18Zm10.42-9.49a1 1 0 1 0 .39-1.96l-.4 1.96Zm6.09 5.54a8 8 0 0 1-.16 5.1l1.87.7a10 10 0 0 0 .2-6.38l-1.91.58Zm-.16 5.1a8 8 0 0 1-3.23 3.97l1.07 1.7a10 10 0 0 0 4.03-4.97l-1.87-.7Zm-3.23 3.97a8 8 0 0 1-4.96 1.21l-.18 2a10 10 0 0 0 6.21-1.52l-1.07-1.69Zm-4.96 1.21a8 8 0 0 1-4.69-2.05L9.28 23.4a10 10 0 0 0 5.85 2.56l.18-1.99Zm-4.69-2.05a8 8 0 0 1-2.49-4.46l-1.96.36a10 10 0 0 0 3.1 5.58l1.35-1.48Zm-2.49-4.46a8 8 0 0 1 .73-5.06l-1.79-.9a10 10 0 0 0-.9 6.32l1.96-.36Zm.73-5.06a8 8 0 0 1 3.64-3.6l-.88-1.79a10 10 0 0 0-4.55 4.49l1.79.9Zm3.64-3.6a8 8 0 0 1 5.07-.65l.39-1.96a10 10 0 0 0-6.34.82l.88 1.8Z",
    fill: "#0BC196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.31 4 1.75 2.47c.45.63.26 1.5-.4 1.9L16 9.93",
    stroke: "#0BC196",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "m13 19.59 6.09-6.09"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 1,
    fill: "#68F4C9",
    stroke: "#68F4C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.5,
    r: 1,
    fill: "#68F4C9",
    stroke: "#68F4C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturesFundingRateProfit);
export default __webpack_public_path__ + "static/media/futuresFundingRateProfit.ae36c2408a536e2becd20b4f27eaecb5.svg";
export { ForwardRef as ReactComponent };